export default __webpack_public_path__ + "static/media/ask-anything-chat.749c5cd5.svg";